import React, { Component } from 'react';
import Model from './model';
import View from './view';
import Presenter from './presenter';
import Alert from '../../util/alert';

export default class AgeGagePopup extends Component {
  static show(format, minAge, redirect, redirectDelay, onClose) {
    Alert.show((id, close) => (open) => (
      <AgeGagePopup
        key={`age-${id}`}
        open={open}
        minAge={minAge}
        format={format}
        redirect={redirect}
        redirectDelay={redirectDelay}
        onClose={(date) => {
          onClose?.(date);
          close();
        }}
      />
    ));
  }

  constructor(props) {
    super(props);
    const { onClose } = props;
    this.presenter = new Presenter(new Model(this, { index: View.Page.main }), onClose);
  }

  componentDidUpdate() {
    const { onClose } = this.props;
    this.presenter.onClose = onClose;
  }

  render() {
    const { open, minAge, redirect, redirectDelay, format } = this.props;
    return (
      <View
        {...this.state}
        presenter={this.presenter}
        open={open}
        minAge={minAge}
        redirect={redirect}
        redirectDelay={redirectDelay}
        format={format}
      />
    );
  }
}
